import { useEffect, useState } from "react";
import { loadAutoWithdrawConfig } from "../utils/autoWithdraw";

export default function useAutoWithdrawRuntime({ userId }) {
  const [, setAutoWithdrawConfig] = useState(null);
  const [alertState, setAlertState] = useState({
    open: false,
    type: "success",
    text: "",
  });

  useEffect(() => {
    if (!userId) {
      setAutoWithdrawConfig(null);
      return;
    }

    const reloadConfig = () => {
      setAutoWithdrawConfig(loadAutoWithdrawConfig(userId));
    };

    reloadConfig();

    const onConfigChanged = (event) => {
      const changedUserId = String(event?.detail?.userId ?? "");
      if (changedUserId && changedUserId !== String(userId)) return;
      reloadConfig();
    };

    const onStorage = () => reloadConfig();

    window.addEventListener("app:autoWithdrawConfigChanged", onConfigChanged);
    window.addEventListener("storage", onStorage);

    return () => {
      window.removeEventListener(
        "app:autoWithdrawConfigChanged",
        onConfigChanged,
      );
      window.removeEventListener("storage", onStorage);
    };
  }, [userId]);

  return {
    autoWithdrawAlert: alertState,
    closeAutoWithdrawAlert: () =>
      setAlertState((prev) => ({ ...prev, open: false })),
  };
}
